"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPaymentRequestsByOrderId = void 0;
const getPaymentRequestsByOrderId = async (supabase, id) => {
    const { data, error } = await supabase
        .from("payment_requests")
        .select(`*,
    invoice:transactions!invoice_id(*),
    payment_provider:payment_methods!payment_provider_id(*)
    `)
        .eq("order_id", id);
    if (!error)
        return data;
    return error;
};
exports.getPaymentRequestsByOrderId = getPaymentRequestsByOrderId;
